import videos2025 from './2025';
import videos2024 from './2024';
import videos2023 from './2023';

// Combine all video data
const videosData = {
  2025: videos2025,
  2024: videos2024,
  2023: videos2023
};

// Helper functions for year-based navigation
export const getAvailableYears = () => {
  return Object.keys(videosData)
    .map(year => parseInt(year))
    .sort((a, b) => b - a); // Latest year first
};

// Get all videos for a specific year
export const getVideosForYear = (year) => {
  return videosData[year] || [];
};

// Get year statistics for year cards
export const getYearStats = (year) => {
  const videos = videosData[year] || [];
  
  // Get thumbnail from first available video
  const thumbnail = videos.length > 0 
    ? (videos[0].thumbnail || videos[0].poster)
    : null;
  
  return {
    year,
    videoCount: videos.length,
    thumbnail
  };
};

// Get a specific video by ID
export const getVideoById = (year, videoId) => {
  const videos = videosData[year] || [];
  return videos.find(video => video.id === parseInt(videoId));
};

export default videosData;

